<script lang="ts">
	import { getContextScope } from '$lib/js/helpers/i18n'

	const scope = getContextScope()
</script>

<a
	href="https://{scope}.trustpilot.com/review/bixoto.com?utm_medium=trustbox&utm_source=MicroReviewCount"
	class="trustpilot"
	target="_blank"
	rel="noopener noreferrer"
>
	<p>Lee nuestras <span>1892</span> reseñas en</p>
	<img src="/images/icons/trustpilot.png" loading="lazy" alt="Trustpilot reviews" title="Trustpilot reviews"
			 height="74" width="300">
</a>


<style lang="scss">
  .trustpilot {
    display: flex;
    align-items: center;
    justify-content: center;
    color: black;
    margin-top: 20px;

    p {
      margin-top: 2px;
      margin-right: 5px;
    }

    span {
      font-weight: 700;
    }

    img {
      height: 100%;
      width: 80px;
    }
  }
</style>
